// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.choose-date {
  margin-top: 15px;
}

mat-form-field {
  width: 100%;
  margin: 10px auto;
}

.lower-right-button {
  position: absolute;
  bottom: 0;
  right: 1%;
}

.separator {
  height: 15px;
}

.modal-content {
  padding: 15px;
}
.modal-content .div-see {
  overflow-y: auto;
}
.modal-content .div-see .card {
  width: 100%;
  margin: 10px auto;
}
.modal-content .div-see .card .id {
  color: rgb(173, 173, 173);
  font-style: italic;
}
.modal-content .non_inherited {
  color: #8BB7F0;
}`, "",{"version":3,"sources":["webpack://./src/app/+home/+my-libraries/+sites/document-library/shared/dialog-add-alert/dialog-add-alert.component.scss"],"names":[],"mappings":"AAAA;EACI,gBAAA;AACJ;;AAEE;EACE,WAAA;EACA,iBAAA;AACJ;;AAGE;EACE,kBAAA;EACA,SAAA;EAED,SAAA;AADH;;AAGA;EACE,YAAA;AAAF;;AAGA;EACE,aAAA;AAAF;AAEE;EACE,gBAAA;AAAJ;AAEI;EACE,WAAA;EACA,iBAAA;AAAN;AAEM;EACE,yBAAA;EACA,kBAAA;AAAR;AAKE;EACE,cAAA;AAHJ","sourcesContent":[".choose-date {\r\n    margin-top: 15px;\r\n  }\r\n\r\n  mat-form-field {\r\n    width: 100%;\r\n    margin: 10px auto;\r\n  }\r\n\r\n \r\n  .lower-right-button{\r\n    position:absolute;\r\n    bottom: 0;\r\n\r\n   right: 1%;\r\n}\r\n.separator {\r\n  height: 15px;\r\n}\r\n\r\n.modal-content {\r\n  padding: 15px;\r\n\r\n  .div-see {\r\n    overflow-y: auto;\r\n\r\n    .card {\r\n      width: 100%;\r\n      margin: 10px auto;\r\n\r\n      .id {\r\n        color: rgb(173, 173, 173);\r\n        font-style: italic;\r\n      }\r\n    }\r\n  }\r\n\r\n  .non_inherited {\r\n    color: #8BB7F0;\r\n  }\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
